import classNames from 'classnames';
import { Column, Row, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { OutlineArrowRightIcon } from '@tempmee/react-icons';
import './ShiftCard.scss';

export interface IShiftCardProps {
  title: string;
  count: number;
  barColor: string;
  ctaText?: string;
  isClickable: boolean;
  onClick?: () => void;
  countColor?: string;
  isLoading?: boolean;
  showCtaWhenEmpty?: boolean;
  emptyStateMessage?: string;
  dataCy?: string;
  countDataCy?: string;
}


export const ShiftCard = ({
  title,
  count,
  barColor,
  ctaText,
  isClickable,
  onClick,
  countColor,
  isLoading,
  showCtaWhenEmpty = false,
  emptyStateMessage,
  dataCy,
  countDataCy,
}: IShiftCardProps) => {
  const isActive = count > 0 && !isLoading;
  const showBar = isClickable && (isActive || showCtaWhenEmpty);
  const shouldShowCta = isClickable && ctaText && (isActive || showCtaWhenEmpty);
  const showEmptyMessage = !isActive && !isLoading && emptyStateMessage;

  const cardClassName = classNames('shift-card', {
    'shift-card--clickable': isClickable,
    'shift-card--not-clickable': !isClickable,
    'shift-card--active': isActive || shouldShowCta,
  });

  return (
    <div onClick={isClickable ? onClick : undefined} className={cardClassName} data-cy={dataCy}>
      {isLoading ? (
        <div className="shift-card__skeleton">
          <div className="shift-card__skeleton-count" />
          <div className="shift-card__skeleton-title" />
        </div>
      ) : (
        <>
          <Column>
            <Typography
              size="heading_1"
              bold
              color={isActive ? countColor || colors.neutral[600] : colors.neutral[200]}
              data-cy={countDataCy}
            >
              {count}
            </Typography>

            <Typography size="heading_3">{title}</Typography>
          </Column>

          {shouldShowCta && (
            <Row align="center" gap={3} justify="end">
              <OutlineArrowRightIcon className="shift-card__arrow" color={barColor} />
              <Typography size="body_large" bold>
                {ctaText}
              </Typography>
            </Row>
          )}

          {showBar && <div className="shift-card__bar" style={{ backgroundColor: barColor }} />}
          {showEmptyMessage && (
            <div className="shift-card__empty-message" style={{ backgroundColor: barColor }}>
              <Typography color={colors.shades['0']}>{emptyStateMessage}</Typography>
            </div>
          )}
        </>
      )}
    </div>
  );
};
